<!-- 标题 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Form :model="newFormData" label-position="left" :label-width="80">
                <div class="form-title mb-24">标题内容</div>
                <FormItem label="标题文字">
                    <Input v-model="newFormData.content.text" placeholder="标题文字"></Input>
                </FormItem>
                <FormItem label="文字大小">
                    <Input v-model="newFormData.content.size" placeholder="文字大小"></Input>
                </FormItem>
                <FormItem label="文字位置">
                    <RadioGroup v-model="newFormData.content.position" type="button">
                        <Radio label="left"><Icon type="md-menu"/></Radio>
                        <Radio label="center"><Icon type="md-funnel"/></Radio>
                        <Radio label="right"><Icon type="md-menu"/></Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="文字颜色">
                    <ColorPicker v-model="newFormData.content.text_color"/>
                </FormItem>
                <div class="form-title">背景设置</div>
                <FormItem label="背景颜色">
                    <ColorPicker v-model="newFormData.content.bg_color"/>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
</style>